// src/router/Routes.js
import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layouts
import MainLayout from "../layouts/MainLayout";
import DashboardLayout from "../layouts/DashboardLayout";

// Public Pages
import Home from "../pages/Home";
import Services from "../pages/Services";
import Catering from "../pages/Catering";
import ChefBooking from "../pages/ChefBooking";
import CloudKitchen from "../pages/CloudKitchen";
import Contact from "../pages/Contact";
import Login from "../pages/Login";
import Register from "../pages/Register";

// Dashboard Pages (Protected)
import Profile from "../pages/Profile";
import Dashboard from "../pages/Dashboard";
import MyChefBookings from "../pages/MyChefBookings";
import MyCateringBookings from "../pages/MyCateringBookings";
import MyDailyFoodBookings from "../pages/MyDailyFoodBookings";

// Admin
import AdminPanel from "../pages/AdminPanel";

// Misc
import NotFound from "../pages/NotFound";

// Components
import ProtectedRoute from "../components/ProtectedRoute";

// Context
import { AuthContext } from "../context/AuthContext";

const AppRoutes = () => {
  const { authReady } = useContext(AuthContext);

  // Global auth gate loader (prevents route flicker)
  if (!authReady) {
    return <FullScreenLoader />;
  }

  return (
    <Routes>
      {/* =======================
          Main Public Layout
         ======================= */}
      <Route element={<MainLayout />}>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/catering" element={<Catering />} />
        <Route path="/chef-booking" element={<ChefBooking />} />
        <Route path="/cloud-kitchen" element={<CloudKitchen />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Public Fallback */}
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* =======================
          Dashboard Layout (Protected)
         ======================= */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        {/* Default dashboard home */}
        <Route index element={<Dashboard />} />

        {/* Profile */}
        <Route path="profile" element={<Profile />} />

        {/* Bookings */}
        <Route path="mychefbookings" element={<MyChefBookings />} />
        <Route path="mycateringbookings" element={<MyCateringBookings />} />
        <Route path="mydailyfoodbookings" element={<MyDailyFoodBookings />} />

        {/* Admin (nested, protected) */}
        <Route
          path="admin"
          element={
            <ProtectedRoute adminOnly>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* =======================
          Legacy Redirects (Backward Compatibility)
         ======================= */}
      <Route
        path="/profile"
        element={<Navigate to="/dashboard/profile" replace />}
      />
      <Route
        path="/my-chef-bookings"
        element={<Navigate to="/dashboard/mychefbookings" replace />}
      />
      <Route
        path="/my-catering-bookings"
        element={<Navigate to="/dashboard/mycateringbookings" replace />}
      />
      <Route
        path="/my-daily-food-bookings"
        element={<Navigate to="/dashboard/mydailyfoodbookings" replace />}
      />

      {/* =======================
          Global Fallback
         ======================= */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;

/* =======================
   Components
   ======================= */

const FullScreenLoader = () => {
  return (
    <div className="fullscreen-loader">
      Checking authentication…
    </div>
  );
};
